<template>
  <div>
    <div class="pr-4 pb-4">
      <v-text-field
        light
        label="Title"
        v-model="item.name"
        type="text"
        required
        color="amber"
        placeholder="Name"
      ></v-text-field>

      <v-textarea
        light
        label="Challenge"
        v-model="item.challenge"
        type="text"
        required
        color="amber"
        placeholder="What is the key challenge"
        :rows="3"
      ></v-textarea>

      <v-textarea
        light
        label="Context"
        v-model="item.body"
        type="text"
        required
        color="amber"
        placeholder="Description"
        :rows="3"
      ></v-textarea>

      <unit-sub-items
        v-model="item.points"
        name="sub"
        :key="`points-${item.id}`"
      >
        <v-label>Supporting points</v-label>
        <p class="ma-0">Type below and press <strong>Add</strong></p>
      </unit-sub-items>

      <v-select
        :items="local.categories"
        label="Categories"
        multiple
        v-model.trim="item.categories"
        light
      ></v-select>

      <v-select
        :items="local.tags"
        label="Tags"
        multiple
        v-model.trim="item.tags"
        light
      ></v-select>

      <v-select
        :items="local.themes"
        label="Themes"
        multiple
        v-model.trim="item.themes"
        light
      ></v-select>

      <v-select
        light
        :items="colors"
        label="Colour code"
        :value="item.color"
        v-model.trim="item.color"
        item-text="title"
        item-value="color"
        class="mr-4 mt-8"
      ></v-select>

      <v-switch
        v-model="item.disabled"
        label="Disable"
        color="amber"
        class=""
        inset
      ></v-switch>

      <v-slider
        v-model="item.priority"
        label="Priority"
        step="1"
        min="0"
        max="3"
        ticks="always"
        tick-size="1"
        color="amber text--black"
        track-color="grey lighten-2"
        light
      ></v-slider>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { itemModel } from "./model";
import { UnitSubItems } from "@/components/units";

export default {
  name: "ChallengesSystemForm",
  components: { UnitSubItems },
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1],
    };
  },
  methods: {
    createItem(item) {
      const proto = {};
      Object.keys(itemModel).forEach((key) => {
        proto[key] = item[key] ? item[key] : itemModel[key];
      });
      return proto;
    },
    submit() {
      this.$emit("submit", this.item);
    },
    cancel() {
      this.$emit("cancel", this.item);
    },
  },
};
</script>
